const { VITE_CONVERSATIONS_API } = import.meta.env;

/**
 * Per-user preferences on the conversations service. The trailing slash matches
 * the backend route (`/api/conversations/v1/preferences/`) so the request hits
 * it directly instead of relying on a 307 slash redirect.
 */
export const userPreferencesPath = () => `${VITE_CONVERSATIONS_API}/preferences/`;

export interface UserPreferencesResponse {
  /** ISO timestamp of when the user accepted the MCP guidelines, or `null` if
   *  they never have. */
  mcp_guidelines_accepted_at: string | null;
}

export interface UserPreferencesUpdate {
  accept_mcp_guidelines: boolean;
}
